import { BaseApi } from '@smorder/logic';

class OrderApi extends BaseApi {
  * loadOrders() {
    return yield this.authorizedFetch('/api/v1/orders', {
      method: 'GET',
    });
  }

  * loadOrder(orderId) {
    return yield this.authorizedFetch(`/api/v1/orders/${orderId}`, {
      method: 'GET',
    });
  }

  * proceedOrder(orderId, printerId = null) {
    return yield this.authorizedFetch(`/api/v1/order/${orderId}/state`, {
      method: 'POST',
      parseAsText: true,
      body: printerId ? JSON.stringify({ printerId }) : undefined,
    });
  }

  * printOrder(orderId, type, printerId) {
    let url = `/api/v1/order/${orderId}/print?type=${type}&immediatePrint=true`;

    if (printerId) {
      url += `&printerId=${printerId}`;
    }

    return yield this.authorizedFetch(url, {
      method: 'PUT',
      parseAsText: true,
    });
  }

  * printProductLabels(printLabeDto) {
    let url = `/api/v1/order/print-labels`;


    return yield this.authorizedFetch(url, {
      method: 'PUT',
      parseAsText: true,
      body: JSON.stringify(printLabeDto),
    });
  }

  * ninjasCheckPossible(orderId) {
    let url = `/api/v1/external/ninjas/possible?orderId=${orderId}`;

    return yield this.authorizedFetch(url, {
      method: 'POST',            
    });
  }

  * ninjasExportOrder(orderId) {
    let url = `/api/v1/external/ninjas/export?orderId=${orderId}`;

    return yield this.authorizedFetch(url, {
      method: 'POST',            
    });
}

  * downloadLabels(downloadDto) {
    let url = `/api/v1/order/download-labels`;

    return yield this.authorizedDownload(url, {
      method: 'PUT',      
      filename: 'Ettiketten.pdf',
      body: JSON.stringify(downloadDto),
    });
  }

  * printReport({ locationId, widgetId, start, end }) {
    let url = `/api/v1/locations/${locationId}/print-report?widgetId=${widgetId}`;

    if (start) {
      url += `&start=${start}`;
    }

    if (end) {
      url += `&end=${end}`;
    }

    return yield this.authorizedFetch(url, {
      method: 'POST',
    });
  }

  * loadReports() {
    return yield this.authorizedFetch('/api/v1/reports', {
      method: 'GET',
    });
  }

  * declineOrder({ order, note, blockUser }) {
    return yield this.authorizedFetch(`/api/v1/order/${order.id}`, {
      method: 'DELETE',
      body: JSON.stringify({ Note: note, LockUser: blockUser }),
      parseAsText: true,
    });
  }

  * findOrderByInvoice({ locationId, code }) {
    return yield this.authorizedFetch(`/api/v1/location/${locationId}/OrderForInvoice`, {
      method: 'POST',
      body: JSON.stringify({ code }),
    });
  }

  * setDeliveryTime({ orderId, deliveryTime }) {
    return yield this.authorizedFetch(`/api/v1/order/${orderId}/set-delivery-time`, {
      method: 'POST',
      body: JSON.stringify({ deliveryTime }),
    });
  }
}

export default OrderApi;
